// extracted by mini-css-extract-plugin
export default {"container":"UserIcons_container__oDPG1","icon":"UserIcons_icon__2lQrP"};